import React from "react";
import LabelH4 from "./LabelH4";

export default function CustomForm2({
    children,
    header,
    formClass,
    extraClassName,
    title,
    col,
    titleCol
}) {
    return (
        <div className="py-4">
            {title ? (
                <LabelH4 title={title} />
            ) : null}
            {header ? (
                <div className={`col-${col || "2"} title my-auto`}>{header}</div>
            ) : null}
            {children}
        </div>
    );
}